import React, { Component } from "react";
import { HashLink as Link } from "react-router-hash-link";
import Form from "../components/form";
import DesktopCarousel from "../components/homedartistsect";
import TabletArtistSection from "../components/hometartistsect";
import scrollToTop from "../components/scrolltoTop";
import noscrollOffset from "../components/noscrollOffset";
import logos_spotify from "../images/logos_spotify.png";
import lineicons_apple_music_alt from "../images/lineicons_apple_music_alt.png";
import logos_youtube from "../images/logos_youtube.png";

export default class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: "",
        email: "",
        message: "",
      },
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

  render() {
    const { formData } = this.state;

    const fields = [
      {
        name: "name",
        label: "Name",
        type: "text",
        required: true,
        autoComplete: "name",
      },
      {
        name: "email",
        label: "Email",
        type: "email",
        required: true,
        autoComplete: "email",
      },
    ];

    return (
      <>
        <div className="home-page-container">
          {/* Hero Section */}
          <section className="home-hero" id="hero">
            <img
              src="https://d1g9iww9o5ioh1.cloudfront.net/leaves/rightSmallLeaves.webp"
              className="right-small-leaves small-leaves leaves"
              alt="leaves"
            />
            <div className="sect1">
              <img
                src="https://d1g9iww9o5ioh1.cloudfront.net/home_page/hero.webp"
                alt=""
                fetchpriority="high"
              />
            </div>
            <div className="home-hero-text-container">
              <h1>Harmonising hearts and heritage</h1>
              <span className="desktop-hero-text">
                We are The AfroCollective,
                <br />
                Home of UK Afro Fusion
              </span>
              <Link to="/about" onClick={scrollToTop}>
                <button className="home-hero-btn">More about us</button>
              </Link>
            </div>
          </section>

          {/* Get to Know Us Section */}
          <section className="gtku">
            <div className="gtku-content-container">
              <div className="gtku-content">
                <h2>Get to know us!</h2>
                <p>
                  We curate vibrant events that spotlight Afro-fusion music and
                  artists, creating immersive experiences that connect audiences
                  with the rich sounds of the genre. We are dedicated to:
                </p>
                <Link to="/about" onClick={scrollToTop}>
                  <button className="gtku-btn">Learn more about The AfroCollective</button>
                </Link>
              </div>
              <div className="usp-wrapper">
                <div className="usp-container">
                  <Link to="/about#about-provide" scroll={noscrollOffset}>
                    <div className="usp">
                      <img
                        src="https://d1g9iww9o5ioh1.cloudfront.net/home_page/spotlight.webp"
                        className="usp-img"
                        alt="usp-img"
                      />
                      <span className="usp-text">
                        Providing a platform for UK Afrofusion artists to reach
                        new audiences
                      </span>
                    </div>
                  </Link>

                  <Link to="/about#about-connect" scroll={noscrollOffset}>
                    <div className="usp">
                      <img
                        src="https://d1g9iww9o5ioh1.cloudfront.net/home_page/calender.webp"
                        className="usp-img"
                        alt="usp-img"
                      />
                      <span className="usp-text">
                        Organising events for the community, connecting artists
                        and their supporters
                      </span>
                    </div>
                  </Link>
                  <Link to="/about#about-what" scroll={noscrollOffset}>
                    <div className="usp">
                      <img
                        src="https://d1g9iww9o5ioh1.cloudfront.net/home_page/promotion.webp"
                        className="usp-img"
                        alt="usp-img"
                      />
                      <span className="usp-text">
                        Promoting Afrofusion with the hopes of it outlasting
                        Afroswing
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
              <Link to="/about" onClick={scrollToTop}>
                <button className="tablet-gtku-btn">Learn more</button>
              </Link>
            </div>
          </section>
          {/*What's new*/}
          <section className="update-section">
            <h2>New releases</h2>
            <div className="new-release-content">
              <div className="img-cont">
                <img
                  className="mymindalbumart"
                  src="https://d1g9iww9o5ioh1.cloudfront.net/blog/summerintosound.webp"
                  alt="album art"
                />
              </div>

              <div className="new-release-text">
                <div className="sect-div">
                  <h3>
                    Pressed Play and felt the Sun: Osas turns Summer into a
                    Soundtrack
                  </h3>
                  <p>
                    With the weather as bad as it is, this is the perfect time
                    to uncover the true sounds of Summer...
                    <span> </span>
                    <Link to="/blog/summerintosoundtrack" onClick={scrollToTop}>
                      read more
                    </Link>

                  </p>
                </div>
                <div className="sect-div">
                  <h3>Out now on all platforms!</h3>
                  <div id="sm-full">
                    <Link to="https://open.spotify.com/album/5zLFdQ4AEQQnXvobzEWSQU?si=aNGpg7HDTWioEWFcRC6cwQ">
                      <img src={logos_spotify} alt="spotify logo" />
                    </Link>
                    <Link to="https://music.apple.com/gb/album/sounds-of-summer-ep/1825503075">
                      <img
                        src={lineicons_apple_music_alt}
                        alt="apple music logo"
                      />
                    </Link>
                    <Link to="https://www.youtube.com/playlist?list=OLAK5uy_mWos_xAXrCHpRGyMiPlwcxhCw7JtEAvlc">
                      <img src={logos_youtube} alt="youtube logo" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Home events section Section */}
          <section className="home-events">
            <div className="home-event-container">
              <h2>Be at our next event!</h2>
              <p>
                Join us for an unforgettable night filled with dynamic live
                performances, vibrant dance, and an atmosphere that will keep
                you moving all night. Don’t lack, secure your spot now!
              </p>
              <div className="percs-container">
                <div className="perc">
                  <img
                    src="https://d1g9iww9o5ioh1.cloudfront.net/home_page/afrofusion.webp"
                    alt="afrofusion"
                  />
                  <span>Afrofusion</span>
                </div>
                <div className="perc">
                  <img
                    src="https://d1g9iww9o5ioh1.cloudfront.net/home_page/livemusic.webp"
                    alt="live performances"
                  />
                  <span>Live performances</span>
                </div>
                <div className="perc">
                  <img
                    src="https://d1g9iww9o5ioh1.cloudfront.net/home_page/djsets.webp"
                    alt="DJ sets"
                  />
                  <span>DJ sets</span>
                </div>
                <div className="perc">
                  <img
                    src="https://d1g9iww9o5ioh1.cloudfront.net/home_page/bar.webp"
                    alt="drinks"
                  />
                  <span>Drinks</span>
                </div>
              </div>

              <Link to="/events" onClick={scrollToTop}>
                <button className="home-events-btn">View Events</button>
              </Link>
            </div>
          </section>

          <section className="home-desktop-artists">
            <img
              src="https://d1g9iww9o5ioh1.cloudfront.net/leaves/leftSmallLeaves.webp"
              className="left-small-leaves small-leaves leaves"
              alt="leaves"
            />
            <img
              src="https://d1g9iww9o5ioh1.cloudfront.net/leaves/rightSmallLeaves.webp"
              className="right-small-leaves small-leaves leaves"
              alt="leaves"
            />
            <div className="home-artists-text">
              <h2>The artists</h2>
              <p>
                Our platform has created a community within the Afro-fusion
                scene, connecting the artists to their supporters.
              </p>
            </div>
            {/*Desktop artist section*/}
            <DesktopCarousel />
            {/*Tablet artist section*/}
            <TabletArtistSection />
            <Link to="/artists" onClick={scrollToTop}>
              <button>Meet our artists</button>
            </Link>
          </section>

          {/* Mailing List Section */}
          <section className="mailing-list-section form">
            <div className="form-img-container">
              <img
                src="https://d1g9iww9o5ioh1.cloudfront.net/home_page/mailinglist.webp"
                className="form-img"
                alt="mailing-list-img"
              />
            </div>
            <Form
              fields={fields}
              formid="Mailing"
              first="Sign up to our mailing list"
              second="Get early ticket access, exclusive access to discount codes,
                  and more!"
              third=""
              formData={formData}
              onChange={this.handleChange}
            />
          </section>
        </div>
      </>
    );
  }
}
